import { defineMessages } from 'react-intl';

export const messages: {
	step1Heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	step1Body: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	step2Heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	step2Body: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	step3Heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	step3Body: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createSecondaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createPrimaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	detailsGotIt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	progressIndicator: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	step1Heading: {
		defaultMessage: 'Add component',
		description: 'Heading for status page create component spotlight step 1',
		id: 'status-page.create-component.spotlight.step1.heading',
	},
	step1Body: {
		defaultMessage: 'Customize each component and link it to a service',
		description: 'Body for status page create component spotlight step 1',
		id: 'status-page.create-component.spotlight.step1.body',
	},
	step2Heading: {
		defaultMessage: 'Group components',
		description: 'Heading for status page create component spotlight step 2',
		id: 'status-page.create-component.spotlight.step2.heading',
	},
	step2Body: {
		defaultMessage: 'Organize your components by adding them to specific groups.',
		description: 'Body for status page create component spotlight step 2',
		id: 'status-page.create-component.spotlight.step2.body',
	},
	step3Heading: {
		defaultMessage: 'Manage and organize',
		description: 'Heading for status page create component spotlight step 3',
		id: 'status-page.create-component.spotlight.step3.heading',
	},
	step3Body: {
		defaultMessage: 'Add multiple components and groups for better structure and clarity.',
		description: 'Body for status page create component spotlight step 3',
		id: 'status-page.create-component.spotlight.step3.body',
	},
	createSecondaryAction: {
		defaultMessage: 'Dismiss',
		description: 'Secondary action for status page create component spotlight',
		id: 'status-page.create-component.spotlight.action',
	},
	createPrimaryAction: {
		defaultMessage: 'Next',
		description: 'Primary action for status page create component spotlight',
		id: 'status-page.create-component.spotlight.primary-action',
	},
	detailsGotIt: {
		defaultMessage: 'Ok, got it',
		description: 'Primary action for final step of status page create component spotlight',
		id: 'status-page.create-component-details.spotlight.got-it',
	},
	progressIndicator: {
		defaultMessage: '{currentStep}/{totalSteps}',
		description: 'Progress indicator for spotlight steps',
		id: 'statuspage.create-component-spotlight.progress',
	},
});
